import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from "component/utils/DatatableStyles";

const paginationOptions = {
  rowsPerPageText: "Show Per Page:",
  rangeSeparatorText: "dari",
};

const Datatables = ({ data, onDeleteAccess }) => {
  const [search, setSearch] = useState("");

  // Tambahkan nomor urut dan format data
  const formattedData = data.map((item, index) => ({
    id: index + 1,
    ...item,
  }));

  // Filter berdasarkan menu_desc (bisa ditambah menu_path juga)
  const filteredData = formattedData.filter((item) =>
    [item?.menu_desc, item?.menu_path]
      .some((field) =>
        field?.toString().toLowerCase().includes(search.toLowerCase())
      )
  );

  const columns = [
    {
      name: "No",
      selector: (row) => row.id,
      center: true,
      minWidth: "30px",
    },
    {
      name: "Menu",
      selector: (row) => row.menu_desc,
      minWidth: "100px",
      sortable: true,
    },
    // {
    //   name: "Path",
    //   selector: (row) => row.menu_path,
    //   minWidth: "100px",
    //   sortable: true,
    // },
    {
      name: "Insert",
      selector: (row) => row.ins,
      center: true,
      minWidth: "30px",
    },
    {
      name: "Update",
      selector: (row) => row.upd,
      center: true,
      minWidth: "30px",
    },
    {
      name: "Delete",
      selector: (row) => row.del,
      center: true,
      minWidth: "30px",
    },
    {
      name: "Save",
      selector: (row) => row.sav,
      center: true,
      minWidth: "30px",
    },
    {
      name: "Report",
      selector: (row) => row.rpt,
      center: true,
      minWidth: "30px",
    },
    {
      name: "Query",
      selector: (row) => row.qry,
      center: true,
      minWidth: "30px",
    },
    {
      name: "Action",
      minWidth: "80px",
      maxWidth: "200px",
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cell: (row) => (
        <div>
          <button
            className="btn btn-sm rounded-circle btn-danger"
            onClick={() => onDeleteAccess(row)}
          >
            <i className="bx bx-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const customStylesOverride = {
    ...DatatableStyles,
    headCells: {
      ...DatatableStyles.headCells,
      style: {
        ...DatatableStyles.headCells.style,
        fontSize: "14px",
      },
    },
    cells: {
      ...DatatableStyles.cells,
      style: {
        ...DatatableStyles.cells.style,
        fontSize: "12.5px",
      },
    },
  };

  return (
    <div className="col-lg-12 mb-4">
      <div className="d-flex justify-content-start align-items-center mb-2">
        <input
          type="text"
          placeholder="Search menu..."
          className="form-control w-100"
          style={{ maxWidth: "250px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="datatable-container">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover={false}
          customStyles={customStylesOverride}
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 25]}
          paginationComponentOptions={paginationOptions}
          responsive
        />
      </div>
    </div>
  );
};

export default Datatables;
